export default __webpack_public_path__ + "static/Pala_2-5b7337e9f584dd99c7cfebf36d645068.png";